import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let isConfigured = false;

export const configureGoogleMaps = (apiKey: string): void => {
  if (isConfigured) return;

  setOptions({ key: apiKey, language: 'en', v: 'weekly' });
  isConfigured = true;
};

export const loadPlacesLibrary = (): Promise<google.maps.PlacesLibrary> => {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    return Promise.reject(new Error('VITE_GOOGLE_MAPS_API_KEY is not configured'));
  }

  configureGoogleMaps(apiKey);

  return importLibrary('places');
};
